import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F9F7F5] flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-white border-[#E5E0DC]">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 mx-auto bg-status-warning/10 rounded-full flex items-center justify-center mb-4">
            <XCircle className="w-12 h-12 text-status-warning" />
          </div>
          <h1 className="font-heading text-2xl text-secondary mb-2">
            Paiement annulé
          </h1>
          <p className="text-muted-foreground mb-6">
            Votre paiement a été annulé. Aucun montant n'a été débité.
          </p>
          <div className="flex gap-3 justify-center">
            <Button
              onClick={() => navigate("/mes-paiements")}
              variant="outline"
            >
              Retour aux cotisations
            </Button>
            <Button
              onClick={() => navigate("/")}
              className="bg-primary hover:bg-primary-hover"
            >
              Tableau de bord
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
